import { Button } from "@mui/material";
import React from "react";
import { ErrorBoundary, FallbackProps } from "react-error-boundary";

interface JSXElement {
  children: JSX.Element
};

const FallBackError = ({ error, resetErrorBoundary }: FallbackProps) => {
  return (
    <>
      <div className="alert alert-danger" role="alert">
        <h2>Fatal error occurred in application. Please check logs for details</h2>
        <p>{error.message}</p>
      </div>
      <Button onClick={resetErrorBoundary} >Reset to Home Page</Button>
    </>
  )
};

const ErrorHandler = (error: Error, info: { componentStack: string }) => {
  console.error(error);
  console.error(info.componentStack);
};

export const FatalErrorBoundary = ({ children }: JSXElement) => {
  return (
    <ErrorBoundary
      FallbackComponent={FallBackError}
      onReset={() => { window.location.href = "/" }}
      onError={ErrorHandler}
    >
      {children}
    </ErrorBoundary>
  )
}